import React from 'react';
import './AddChannelModal.css';
import { MessageCircle, Grid, Users } from 'lucide-react';

const AddChannelModal = ({
  showModal,
  handleCloseModal,
  newName,
  setNewName,
  selectedMembers,
  handleMemberRemove,
  memberSearchQuery,
  setMemberSearchQuery,
  isMemberInputFocused,
  setIsMemberInputFocused,
  availableUsers,
  filteredUsers,
  handleMemberSelect,
  handleCreate,
}) => {
  if (!showModal) return null;

  return (
    <div className="acm-overlay" onClick={handleCloseModal}>
      <div className="acm-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          onClick={handleCloseModal}
          className="acm-close-button"
          aria-label="Close modal"
        >
          ×
        </button>

        {/* Header */}
        <div className="acm-header">
          <h2 className="acm-title">Create New Channel</h2>
        </div>

        {/* Channel Name Input */}
        <div className="acm-form-group">
          <label htmlFor="newName" className="acm-label">
            Channel Name
          </label>
          <input
            id="newName"
            type="text"
            placeholder="e.g. marketing-team"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="acm-input"
          />
        </div>

        {/* Add Members Section */}
        <div className="acm-form-group">
          <label className="acm-label">Add Members</label>

          {/* Selected Members */}
          {selectedMembers.length > 0 && (
            <div className="acm-selected-members">
              {selectedMembers.map((member) => (
                <div key={member.id} className="acm-member-tag">
                  <span className="acm-member-name">{member.name}</span>
                  <button
                    type="button"
                    onClick={() => handleMemberRemove(member.id)}
                    className="acm-remove-member"
                    aria-label={`Remove ${member.name}`}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Member Search */}
          <div className="acm-search-container">
            <input
              type="text"
              placeholder="Search and add members..."
              value={memberSearchQuery}
              onChange={(e) => setMemberSearchQuery(e.target.value)}
              onFocus={() => setIsMemberInputFocused(true)}
              onBlur={() => setTimeout(() => setIsMemberInputFocused(false), 200)}
              className="acm-input acm-search-input"
            />

            {/* User Dropdown */}
            {(isMemberInputFocused || memberSearchQuery) && (
              <div className="acm-dropdown">
                {availableUsers.length === 0 ? (
                  <div className="acm-dropdown-empty">No users available</div>
                ) : filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <div
                      key={user.id}
                      onClick={() => handleMemberSelect(user)}
                      className="acm-dropdown-item"
                    >
                      <div className="acm-user-avatar">
                        {user.name.charAt(0).toUpperCase()}
                      </div>
                      <div className="acm-user-name">{user.name}</div>
                    </div>
                  ))
                ) : (
                  <div className="acm-dropdown-empty">No users found</div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Create Button */}
        <button
          onClick={handleCreate}
          disabled={!newName.trim()}
          className={`acm-create-button ${!newName.trim() ? 'acm-create-button-disabled' : ''}`}
        >
          Create Channel
        </button>
      </div>
    </div>
  );
};

export default AddChannelModal;